var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"mr-1",attrs:{"href":"#/"},on:{"click":_vm.showPopup}},[_c('i',{staticClass:"fa-duotone fa-circle-info"})])
}
var staticRenderFns = []

export { render, staticRenderFns }